<template>
  <step :active="0"></step>
  <div class="formDiv">
    <van-form @failed="onFailed" @submit="onSubmit">
      <van-cell-group>
        <!-- 循环显示 -->
        <div v-for="item in formItems" :key="item.key">
          <van-field
            v-if="
              item.key !== 'Gender' &&
              item.key !== 'Country' &&
              item.key !== 'Province' &&
              item.key !== 'City' &&
              item.key !== 'Trade' &&
              item.key !== 'Photo' &&
              item.key !== 'IDCardType' &&
              item.key !== 'ExtField1'
            "
            v-model="formMg[item.key]"
            :name="item.key"
            :label="item.EName"
            :rules="rulesAll[item.key]"
            :class="item.EIsMust ? 'requiredItem' : ''"
            :placeholder="item.EHolder"
            :readonly="
              (item.key === 'Mobile' && tabac === 'dl') ||
              (item.key === 'Email' && tabac === 'gat')
            "
          />
          <!-- 头像 -->
          <van-field
            v-if="item.key === 'Photo'"
            :name="formMg[item.key]"
            label="item.EName"
            :rules="rulesAll.Photo"
            :class="item.EIsMust ? 'photoForm requiredItem' : 'photoForm'"
            v-model="formMg[item.key]"
          >
            <template #input>
              <cropper @send-photo="sendphoto" />
            </template>
          </van-field>
          <!-- gender -->
          <van-field
            v-if="item.key === 'Gender'"
            :class="item.EIsMust ? 'requiredItem' : ''"
            :name="item.key"
            :label="item.EName"
            :rules="rulesAll.Gender"
          >
            <template #input>
              <van-radio-group v-model="formMg.Gender" direction="horizontal">
                <van-radio name="Male">Male</van-radio>
                <van-radio name="Female">Female</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 国家选择pc -->
          <template v-if="item.key === 'Country'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem' : ''"
                :readonly="true"
                v-model="formMg.Country"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.Country"
                :placeholder="item.EHolder"
              >
              </van-field>
              <select v-model="formMg.Country" @change="changeCountry">
                <option
                  v-for="(item, index) in columns"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 国家 移动 -->
            <van-field
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-if="!isPC"
              v-model="formMg.Country"
              is-link
              readonly
              name="Country"
              :label="item.EName"
              @click="showPicker = true"
              :rules="rulesAll.Country"
              :placeholder="item.EHolder"
            >
            </van-field>
            <van-popup v-model:show="showPicker" position="bottom">
              <van-picker
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
          </template>
          <!-- 省份 -->
          <!-- <template v-if="item.key === 'Province'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
                :readonly="true"
                v-model="formMg.Province"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.Province"
                :disabled="formMg.Country !== '中国'"
                :placeholder="item.EHolder"
              >
              </van-field>
              <select
                v-model="formMg.Province"
                @change="changeProvince"
                :disabled="formMg.Country !== '中国'"
              >
                <option
                  v-for="(item, index) in columnsProvince"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <van-field
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-if="!isPC"
              v-model="formMg.Province"
              is-link
              readonly
              :name="item.key"
              :label="item.EName"
              @click="columnsProvince.length > 0 ? (showPickerPro = true) : ''"
              :rules="rulesAll.Province"
              :disabled="formMg.Country !== '中国'"
              :placeholder="item.EHolder"
            />
            <van-popup v-model:show="showPickerPro" position="bottom">
              <van-picker
                :columns="columnsProvince"
                @confirm="onConfirmProvince"
                @cancel="showPickerPro = false"
              />
            </van-popup>
          </template>
          <template v-if="item.key === 'City'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
                :readonly="true"
                v-model="formMg.City"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.City"
                :disabled="formMg.Country !== '中国'"
                :placeholder="item.EHolder"
              >
              </van-field>
              <select
                v-model="formMg.City"
                :disabled="formMg.Country !== '中国'"
              >
                <option
                  v-for="(item, index) in columnsCity"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <van-field
              v-else
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.City"
              is-link
              readonly
              :name="item.key"
              :label="item.EName"
              @click="columnsCity.length > 0 ? (showShopPicker = true) : ''"
              :rules="rulesAll.City"
              :disabled="formMg.Country !== '中国'"
              :placeholder="item.EHolder"
            />
            <van-popup v-model:show="showShopPicker" position="bottom">
              <van-picker
                :columns="columnsCity"
                @confirm="shopConfirm"
                @cancel="showShopPicker = false"
              />
            </van-popup>
          </template> -->
          <!-- 行业 -->
          <template v-if="item.key === 'Trade'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.Trade"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.Trade"
                :placeholder="item.EHolder"
              >
              </van-field>
              <select v-model="formMg.Trade">
                <option
                  v-for="(item, index) in item.Options"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.Trade"
              :name="item.key"
              :label="item.EName"
              @click="showTradePicker = true"
              :rules="rulesAll.Trade"
              :placeholder="item.EHolder"
              readonly
            />
            <van-popup v-model:show="showTradePicker" position="bottom">
              <van-picker
                :columns="tradeOptions"
                @confirm="tradeConfirm"
                @cancel="showTradePicker = false"
              />
            </van-popup>
          </template>
          <!-- ExtField1 -->
          <template v-if="item.key === 'ExtField1'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField1"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.ExtField1"
                :placeholder="item.EHolder"
              >
              </van-field>
              <select v-model="formMg.ExtField1">
                <option
                  v-for="(item, index) in ExtField1Ops"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.ExtField1"
              :name="item.key"
              :label="item.EName"
              @click="showF1Picker = true"
              :rules="rulesAll.ExtField1"
              :placeholder="item.EHolder"
              readonly
            />
            <van-popup v-model:show="showF1Picker" position="bottom">
              <van-picker
                :columns="ExtField1Ops"
                @confirm="f1Confirm"
                @cancel="showF1Picker = false"
              />
            </van-popup>
          </template>
          <!-- ExtField2 -->
          <!-- <template v-if="item.key === 'ExtField2'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField2"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.ExtField2"
              >
              </van-field>
              <select v-model="formMg.ExtField2">
                <option
                  v-for="(item, index) in ExtField2Ops"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <van-field
              v-else
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.ExtField2"
              :name="item.key"
              :label="item.EName"
              @click="showF2Picker = true"
              :rules="rulesAll.ExtField2"
              readonly
            />
            <van-popup v-model:show="showF2Picker" position="bottom">
              <van-picker
                :columns="ExtField2Ops"
                @confirm="f2Confirm"
                @cancel="showF2Picker = false"
              />
            </van-popup>
          </template> -->
          <!-- 身份证件类型 -->
          <template v-if="item.key === 'IDCardType'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.IDCardType"
                :name="item.key"
                :label="item.EName"
                :rules="rulesAll.IDCardType"
                :placeholder="item.EHolder"
              >
              </van-field>
              <select v-model="formMg.IDCardType">
                <option
                  v-for="(item, index) in IDTypes"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.EIsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.IDCardType"
              is-link
              readonly
              :name="item.key"
              :label="item.EName"
              @click="showIDTypePicker = true"
              :rules="rulesAll.IDCardType"
              :placeholder="item.EHolder"
            />
            <van-popup v-model:show="showIDTypePicker" position="bottom">
              <van-picker
                :columns="IDTypes"
                @confirm="IDTypeConfirm"
                @cancel="showIDTypePicker = false"
              />
            </van-popup>
          </template>
        </div>
      </van-cell-group>
      <div style="margin: 16px">
        <van-button
          style="width: 100%"
          :color="btnColor"
          type="primary"
          native-type="submit"
          round
        >
          Next
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import cropper from '@/components/cropper.vue'
import {
  validatorName,
  validatorComName,
  validatorGender,
  validatorRank,
  validateDept,
  validatorMobile,
  validatorEmail,
  validatorAddress,
  validatorUrl,
  validatorFax,
  validateZipCode
} from '@/utils/validators.js'
import { regCId, regIDNumber } from '@/utils/regs.js'
import api from '@/api'
// import cpc from '@/utils/cpc.js'
import { constants } from 'fs'
import step from '@/components/step.vue'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
const btnColor = ref(
  'linear-gradient( 90deg, #02599F 0%, #55A972 80%,  #A1C98B 100%)'
)
const store = useStore()
const token = computed(() => store.state.token)
const ExhCode = computed(() => store.state.ExhCode)
const loginForm = computed(() => store.state.loginForm)
const isPC = computed(() => store.state.isPC)
const mainColor = computed(() => store.state.mainColor)
const openid = computed(() => store.state.openid)
const VisitorID = computed(() => store.state.VisitorID)

const isWeX = computed(() => store.state.isWeX)
const tabac = ref(sessionStorage.getItem('tabac'))
const router = useRouter()
const route = useRoute()
const actid = route.query.id
onMounted(() => {
  getForm()
  wx.getWXSign()
})
const formMg = ref({
  Name: '',
  ComName: '',
  Gender: '', // n
  Rank: '',
  Dept: '', // n
  Mobile: '',
  Country: '',
  Province: '',
  City: '',
  Email: loginForm.value.Email || '',
  Address: '',
  WebUrl: '', // n
  Fax: '', // n
  Tel: '',
  IDCardNo: '',
  Trade: '', // n
  ZipCode: '', // n
  Remark: '', // n
  Photo: '',
  IDCardType: '',
  OpenID: '',
  AliID: ''
})
// 校验省份
const validatorProvince = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      console.log('shengsheng')
      return false
    }
    return true
  }
  return true
}
// 校验城市
const validatorCity = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      return false
    }
    return true
  }
  return true
}
// 校验证件号
const validatorIDCardNo = (val, { required }) => {
  if (required) {
    if (val) {
      if (
        formMg.value.IDCardType === '中国大陆居民身份证' ||
        formMg.value.Country === '中国' ||
        (formMg.value.IDCardType === '' && formMg.value.Country === '')
      ) {
        return regCId(val)
      } else {
        return regIDNumber.test(val)
      }
    }
    return false
  }
  return true
}
const rulesAll = ref({})
const rulesModel = {
  Name: [
    {
      required: false,
      validator: validatorName,
      message: 'Please enter the correct '
    }
  ],
  ComName: [
    {
      required: false,
      validator: validatorComName,
      message: 'Please enter the correct '
    }
  ],
  ComEName: [{ required: false, message: 'Please enter the ' }],
  Gender: [
    {
      required: false,
      validator: validatorGender,
      message: 'Please select the '
    }
  ],
  Rank: [
    {
      required: false,
      validator: validatorRank,
      message: 'Please enter the correct '
    }
  ],
  Dept: [
    { required: false, validator: validateDept, message: 'Please enter the ' }
  ],
  Mobile: [
    {
      required: false,
      // validator: validatorMobile,
      message: 'Please enter the '
    }
  ],
  Country: [{ required: false, message: 'Please select the ' }],
  Province: [
    {
      required: false,
      validator: validatorProvince,
      message: 'Please select the '
    }
  ],
  City: [
    { required: false, validator: validatorCity, message: 'Please select the ' }
  ],
  Email: [
    {
      required: false,
      validator: validatorEmail,
      message: 'Please enter the correct '
    }
  ],
  Address: [
    {
      required: false,
      validator: validatorAddress,
      message: 'Please enter the correct '
    }
  ],
  WebUrl: [
    {
      required: false,
      validator: validatorUrl,
      message: 'Please enter the correct '
    }
  ],
  Fax: [
    {
      required: false,
      validator: validatorFax,
      message: 'Please enter the correct '
    }
  ],
  Tel: [
    {
      required: false,
      validator: validatorFax,
      message: 'Please enter the correct '
    }
  ],
  IDCardNo: [
    {
      required: false,
      validator: validatorIDCardNo,
      message: 'Please enter the correct '
    }
  ],
  Trade: [{ required: false, message: 'Please select the ' }],
  ZipCode: [
    {
      required: false,
      validator: validateZipCode,
      message: 'Please enter the correct '
    }
  ],
  Remark: [{ required: false, message: 'Please enter the ' }],
  Photo: [{ required: true, message: 'Please upload the ' }],
  IDCardType: [{ required: true, message: 'Please select the ' }],
  ExtField1: [{ required: true, message: 'Please select the ' }],
  ExtField2: [{ required: true, message: 'Please enter the ' }]
}
// 解析选项
const dealOp = (str) => {
  if (str) {
    return str.split(';').map((item) => {
      return { text: item, value: item }
    })
  } else {
    return []
  }
}
// 行业选项
const tradeOptions = ref([])
const ExtField1Ops = ref([])
const ExtField2Ops = ref([])
// 获取信息配置
const formItems = ref([])
const getForm = async () => {
  const res = await api.formConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const formObj = JSON.parse(decryptionECB(res.data.configuartion))
    console.log(formObj, 123)
    formItems.value = formObj
      .filter((item) => item.EisShow)
      .sort((a, b) => {
        return a.Sort - b.Sort
      })
    formItems.value.forEach((item) => {
      if (
        item.key === 'Gender' ||
        item.key === 'Country' ||
        item.key === 'Province' ||
        item.key === 'City' ||
        item.key === 'Trade' ||
        item.key === 'Photo' ||
        item.key === 'IDCardType' ||
        item.key === 'ExtField1'
      ) {
        rulesModel[item.key][0].message =
          rulesModel[item.key][0].message + item.EName
        if (item.key === 'Trade') {
          tradeOptions.value = dealOp(item.EOptions)
        }
        if (item.key === 'ExtField1') {
          ExtField1Ops.value = dealOp(item.EOptions)
        }
      } else {
        rulesModel[item.key][0].message =
          rulesModel[item.key][0].message + item.EName
      }
      rulesModel[item.key][0].required = item.EIsMust
      rulesAll.value[item.key] = rulesModel[item.key]
    })
  }
}
// 关闭上传头像
const sendphoto = (data) => {
  console.log(formMg.value, 12333)
  formMg.value.Photo = data
  Object.assign(formMg.value, { Photo: data })
}
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}
// 表单验证成功提交
const onSubmit = async (values) => {
  const subObj = { ...formMg.value }
  subObj.photoUrl = subObj.Photo
  // console.log(subObj)
  // return
  
  const param = {
    ...subObj,
    ExhCode: ExhCode.value,
    token: token.value,
    ifSubmit: true,
    OpenID: '',
    AliID: '',
    invitesource: '1',
    invitesourceid: VisitorID.value,
    lan: 'en'
  }
  if (param.Country) {
    const coutryObj = columns.value.find((item) => {
      return item.text === param.Country
    })
    param.Country = coutryObj.value
  }
  if (param.IDCardType) {
    const IDCardTypeObj = IDTypes.value.find((item) => {
      return item.text === param.IDCardType
    })
    param.IDCardType = IDCardTypeObj.value
  }

  console.log(param, 'ggg')
  const res = await api.visitorSaveApi(param)
  if (res.code === 200) {
    router.go(-1)    
  }
}
// 行业下拉
const showTradePicker = ref(false)
const tradeConfirm = ({ selectedOptions }) => {
  formMg.value.Trade = selectedOptions[0].text
  showTradePicker.value = false
}
// ExtField1 下拉
const showF1Picker = ref(false)
const f1Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField1 = selectedOptions[0].text
  showF1Picker.value = false
}
// ExtField2 下拉
const showF2Picker = ref(false)
const f2Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField2 = selectedOptions[0].text
  showF2Picker.value = false
}
// 国家下拉
const showPicker = ref(false)
const columns = ref([])
const getCountry = () => {
  api.countryApi({}).then((res) => {
    columns.value = res.data.map((item) => {
      return { text: item.ename, value: item.name }
    })
  })
}
getCountry()
const onConfirm = ({ selectedOptions }) => {
  formMg.value.Country = selectedOptions[0].text
  showPicker.value = false
  changeCountry()
}
// 国家变化
const changeCountry = () => {
  // formMg.value.Province = ''
  // formMg.value.City = ''
  // columnsProvince.value = []
  // columnsCity.value = []
  // if (formMg.value.Country === '中国') {
  //   getProsH()
  //   // 修改省份/城市验证
  //   const pRule = rulesAll.value.Province
  //   const cRule = rulesAll.value.City
  //   const findPObj = formItems.value.find((item) => item.key === 'Province')
  //   if (findPObj) {
  //     if (findPObj.EIsMust) {
  //       // 如果必选
  //       pRule[0].required = true
  //     } else {
  //       pRule[0].required = false
  //     }
  //   }
  //   const findCObj = formItems.value.find((item) => item.key === 'City')
  //   if (findCObj) {
  //     if (findCObj.EIsMust) {
  //       // 如果必选
  //       cRule[0].required = true
  //     } else {
  //       cRule[0].required = false
  //     }
  //   }
  //   Object.assign(rulesAll.value, { Province: pRule, City: cRule })
  //   // 修改省份/城市验证 end
  // } else {
  //   // 修改省份/城市验证
  //   const pRule = rulesAll.value.Province
  //   const cRule = rulesAll.value.Province
  //   pRule[0].required = false
  //   cRule[0].required = false
  //   Object.assign(rulesAll.value, { Province: pRule, City: cRule })
  //   // 修改省份/城市验证 end
  // }
  // if (formMg.value.Country === '中国') {
  //   formMg.value.IDCardType = '中国大陆居民身份证'
  // } else if (
  //   formMg.value.Country === '中国香港' ||
  //   formMg.value.Country === '中国澳门'
  // ) {
  //   formMg.value.IDCardType = '港澳通行证'
  // } else if (formMg.value.Country === '中国台湾') {
  //   formMg.value.IDCardType = '台胞证'
  // } else {
  //   formMg.value.IDCardType = '护照'
  // }
}
// 省份下拉
// 获取省份下拉选项
const columnsProvince = ref([])
const getProsH = () => {
  api.proApi({}).then((res) => {
    columnsProvince.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
getProsH()
const showPickerPro = ref(false)
const onConfirmProvince = ({ selectedOptions }) => {
  formMg.value.Province = selectedOptions[0].text
  showPickerPro.value = false
  changeProvince()
}
// 省份变化
const changeProvince = () => {
  formMg.value.City = ''
  columnsCity.value = []
  getCity()
}
// 城市
// 城市下拉
const columnsCity = ref([])
const getCity = () => {
  columnsCity.value = []
  api.cityApi({ name: formMg.value.Province }).then((res) => {
    columnsCity.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
const showShopPicker = ref(false)

const shopConfirm = ({ selectedOptions }) => {
  formMg.value.City = selectedOptions[0].text
  showShopPicker.value = false
}
// 身份证件类型
const IDTypes = ref([
  // { text: '中国大陆居民身份证', value: '中国大陆居民身份证' },
  {
    text: 'Hong Kong and Macau Travel Permit',
    value: '港澳通行证'
  },
  {
    text: 'Taiwan Resident Identity Card',
    value: '台胞证'
  },
  { text: 'Passport', value: '护照' }
])
const showIDTypePicker = ref(false)
const IDTypeConfirm = ({ selectedOptions }) => {
  formMg.value.IDCardType = selectedOptions[0].text
  showIDTypePicker.value = false
}
</script>
<style lang="less">
@import '../../assets/login.less';
.lcbox {
  border: 1px solid #ececec;
  box-sizing: border-box;
  width: 99vw;
  border-radius: 3px;
  margin: 10px auto 0;
}
.fakeSel {
  position: relative;
  .van-field__value {
    opacity: 0;
  }
  select {
    position: absolute;
    top: 50px;
    left: 16px;
    padding: 13px 0;
    width: 93%;
    border: 1px solid #666;
    border-radius: 6px;
    outline: none;
    background: transparent;
    font-weight: normal;
    color: #323233;
    option {
      color: #323233;
    }
  }
}
.formDiv {
  padding: 0 4px;
  width: 92%;
  margin: 0 auto;
  border-radius: 6px;
}
// 头像
.photoForm {
  .van-field__value {
    text-align: center;
  }
  .van-field__body {
    display: inline-block;
    border: 0;
  }
}
</style>
